import Vue from 'vue';
import Vuex from 'vuex';
import snackBar from './modules/utils/snackbar/index';
import cards from './modules/cards/index';
import loading from './modules/utils/loading/index';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    snackBar,
    cards,
    loading,
  },
});
